/*
  if Passing in grouped options flatten out the nested array into one single array
  to make displaying the list and working with refs easier

  The following nested array will transform
  [{
    label: 'Group 1',
    options: [
      {
        value: 1,
        label: 1,
      },
      {
        value: 2,
        label: 2,
      }
    },
    {
    label: 'Group 2',
    options: [
      {
        value: 3,
        label: 3,
      },
      {
        value: 4,
        label: 4,
      }
    }]

    Turns into:

    [
      { label: 'Group1' },
      { value: 1, label: 1, group: "group 1" },
      { value: 2, label: 2, group: "group 1" },
      { label: 'Group 2' },
      { value: 3, label: 3, group: "group 2" },
      { value: 4, label: 4, group: 'group 2 }]
*/
export const flattenOptions = (options) => {
  try {
    const flatOptions = options.flatMap((optionGroup) => {
      if (optionGroup.options) {
        return [
          { label: optionGroup.label },
          ...optionGroup.options.map((subOption) => ({ ...subOption, group: optionGroup.label })),
        ];
      }
      return optionGroup;
    });
    return flatOptions;
  } catch (err) {
    // eslint-disable-next-line
    console.error(`LdsSelect - Error parsing options: ${err}`)
    return options;
  }
};
